import { FormField, Input, useDebounce } from "@aurem/ui";
import { useEffect, useRef, useState } from "react";

type ResourceFilterInputProps = {
  label: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  debounce?: number;
};

export const ResourceFilterInput = ({
  label,
  placeholder,
  value,
  onChange,
  debounce = 300,
}: ResourceFilterInputProps) => {
  const [inputValue, setInputValue] = useState(value);
  const { debouncedValue } = useDebounce<string>(inputValue, debounce);
  const previousDebouncedValue = useRef(debouncedValue);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    if (debouncedValue === previousDebouncedValue.current) return;
    previousDebouncedValue.current = debouncedValue;
    onChange(debouncedValue);
  }, [debouncedValue, onChange]);

  return (
    <FormField label={label}>
      <Input
        value={inputValue}
        placeholder={placeholder}
        onChange={setInputValue}
      />
    </FormField>
  );
};
